module.exports = __webpack_public_path__ + "img/74-Metbrush Mocca.jpg";